/* eslint-disable react/prop-types */
import { useContext, useEffect, useState } from 'react';

import { Controller } from 'react-hook-form';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

import DropDown from './DropDown';

import { UIContext } from '../context/UIContext';

import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers-pro';

dayjs.extend(advancedFormat);

const MoveOutInformation = ({ control, register, errors, leaseExpirationDate, disableForm }) => {
  const { formData } = useContext(UIContext);
  const { primaryResidenceTypes, moveOutReasons } = formData;

  const [maxDate, setMaxDate] = useState();
  const [minDate, setMinDate] = useState();

  const getRangesDates = (range) => {
    let date = new Date(new Date().toLocaleString('en-US'));
    range === 'max' ? date.setMonth(date.getMonth() + 24) : date.setDate(date.getDate());
    return date.toISOString().split('T')[0];
  };

  useEffect(() => {
    setMinDate(getRangesDates('min'));
    setMaxDate(getRangesDates('max'));
  }, []);

  return (
    <div className="bg-white border border-[#BABCC0] rounded w-11/12 lg:m-10 m-3 md:m-6 ">
      <div className="m-5 font-proxima">
        <p className="font-proxima  text-primary text-sm font-semibold mb-1 md:text-subHeader">
          Move-Out Information
        </p>
        <div className="text-tiny md:text-sm">
          {formData?.blockMtm ? (
            <p>
              If&nbsp;
              <span className="font-bold text-[#31343A]">
                move-out date is after your Lease End Date,
              </span>
              &nbsp; you may be billed the higher rate provided in your renewal offer for any days
              up to and including your move-out date. You can locate the required days notice by
              clicking on <span className="font-bold text-[#31343A]">View More Details </span> in
              the <span className="font-bold text-[#31343A]">Important Dates </span> section on this
              screen.
            </p>
          ) : (
            <p>
              If your&nbsp;
              <span className="font-bold text-[#31343A]">
                move-out date is after your Lease End Date,
              </span>
              &nbsp;you will be billed the Month-to-Month (MTM) rate provided in your renewal offer
              for any days up to and including your move-out date. You can locate the required days
              notice by clicking on{' '}
              <span className="font-bold text-[#31343A]">View More Details </span> in the{' '}
              <span className="font-bold text-[#31343A]">Important Dates </span> section on this
              screen.
            </p>
          )}
          <br></br>
          <p>
            If your&nbsp;
            <span className="font-bold text-[#31343A]">
              move-out date is prior to your Lease End Date
            </span>
            ,&nbsp;you will remain liable for Rent and Other Charges through the earlier of your
            Lease End Date or until the date a new resident occupies and begins paying rent for your
            apartment. You may also be liable for any rent damages we may incur. Please refer to
            your Lease Agreement for additional details if you want to end your lease early.
          </p>
        </div>
        <div className="md:flex md:justify-between mt-5">
          <div className="md:w-1/2 text-xs  md:text-sm ">
            <p className="font-semibold">Lease-End Date</p>
            <p className="md:mt-2 text-[#525761]">
              {dayjs(leaseExpirationDate).format('MM/DD/YYYY')}
            </p>
          </div>
          <div className="md:w-1/2 mt-5 md:mt-0 relative">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              <p className=" font-semibold text-xs md:text-sm">
                <span className="text-[#F5222D]">*</span> Move-Out Date
              </p>
            </label>
            <Controller
              control={control}
              name="moveOutDate"
              placeholder={'mm/dd/yy'}
              rules={{
                required: true,
                validate: {
                  min: (date) =>
                    dayjs(date) >= dayjs(minDate) || 'Please select a valid move-out date',
                  max: (date) =>
                    dayjs(date) <= dayjs(maxDate) || 'Please select a valid move-out date'
                }
              }}
              render={({ field: { onChange, ref } }) => (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    id="moveOutDatePicker"
                    name="moveOutDatePicker"
                    disablePast
                    inputRef={ref}
                    onChange={(newValue) => {
                      onChange(newValue);
                    }}
                    maxDate={dayjs(maxDate)}
                    shouldDisableYear={() => false}
                    className={
                      errors.moveOutDate
                        ? 'moveOutDatePicker error-input border-[#F5222D] border rounded w-full py-2 px-3 md:w-11/12 text-gray-700 leading-tight focus:outline-none focus:shadow-outline  cursor-pointer'
                        : 'moveOutDatePicker border border-[#BABCC0]  rounded w-full py-2 px-3 md:w-11/12 text-gray-700 leading-tight focus:outline-none focus:shadow-outline disabled:bg-[#BABCC067]  disabled:text-[#979AA0] disabled:italic disabled:border-slate-200 disabled:shadow-none cursor-pointer'
                    }
                  />
                </LocalizationProvider>
              )}
            />
            {errors?.moveOutDate && (
              <p className="text-[#F5222D] text-[10px] pt-2">Please select a valid move-out date</p>
            )}
            <div
              className={
                disableForm
                  ? 'absolute right-[5.4%] top-[37px]  md:right-[12.4%] md:top-[40px] cursor-pointer  lg:right-[11.4%] lg:top-[38px] pointer-events-none  bg:[#BABCC067]  '
                  : 'absolute right-[5.4%] top-[37px]  md:right-[12.4%] md:top-[40px] cursor-pointer  lg:right-[11.4%] lg:top-[38px] pointer-events-none bg-white  '
              }></div>
          </div>
        </div>

        <div className="md:flex   text-xs md:text-sm md:justify-between mt-5">
          <div className="md:w-1/2 text-xs  md:text-sm">
            <label className="block  text-sm font-bold mb-2">
              <p className="font-semibold text-xs md:text-sm">
                <span className="text-[#F5222D]">*</span> Primary Reason For Moving Out
              </p>
            </label>
            <div>
              <Controller
                control={control}
                name="reasonMoveOut"
                defaultValue=""
                rules={{
                  required: true
                }}
                render={({ field: { onChange, value } }) => (
                  <DropDown
                    onChange={onChange}
                    value={value}
                    name={'reason'}
                    errors={errors}
                    errorName={'reasonMoveOut'}
                    data={moveOutReasons}
                    disableForm={disableForm}
                  />
                )}
              />

              {errors?.reasonMoveOut && (
                <p className="text-[#F5222D] text-[10px] pt-2">
                  Please select primary reason for moving out
                </p>
              )}
            </div>
          </div>
          <div className="md:w-1/2 mt-5 md:mt-0 ">
            <label className="block text-sm font-bold mb-2">
              <p className="font-semibold text-xs md:text-sm">
                <span className="text-[#F5222D] ">*</span> Residence Type You Will Be Moving Into
              </p>
            </label>

            <Controller
              control={control}
              name="residenceTypeMoveIn"
              defaultValue=""
              rules={{
                required: true
              }}
              render={({ field: { onChange, value } }) => (
                <DropDown
                  onChange={(e) => onChange(e)}
                  name={'residence_type'}
                  value={value}
                  errors={errors}
                  errorName={'residenceTypeMoveIn'}
                  data={primaryResidenceTypes}
                  disableForm={disableForm}
                />
              )}
            />
            {errors?.residenceTypeMoveIn && (
              <p className="text-[#F5222D] text-[10px] pt-2">Please select residence type</p>
            )}
          </div>
        </div>

        <div className="text-xs md:text-sm mt-5">
          <label className="block text-sm font-bold mb-2">
            <p className="font-semibold text-xs md:text-sm">Feedback/Comments </p>
          </label>
          <textarea
            className=" appearance-none border border-[#BABCC0] rounded w-full py-2 px-3 md:w-[97%] h-[85px] text-gray-700 leading-tight focus:outline-none focus:shadow-outline disabled:bg-[#BABCC067]  disabled:text-[#979AA0] disabled:italic disabled:border-slate-200 disabled:shadow-none"
            id="feedback"
            disabled={disableForm}
            type="text"
            {...register('feedback')}
            placeholder="Please type here..."
            maxLength={700}
          />
        </div>
      </div>
    </div>
  );
};

export default MoveOutInformation;
